interface UserData {
  id: string;
  email: string;
  user_role: string;
  mobile_number?: string | null;
  first_name?: string;
  last_name?: string;
  educational_info?: {
    class?: string;
  };
}

export const useOneSignalUser = () => {
  const tagUser = async (userData: UserData) => {
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.login(userData.id);
        await OneSignal.User.addEmail(userData.email);

        await OneSignal.User.addTags({
          last_login: new Date().toISOString(),
          user_id: userData.id,
          email: userData.email,
          user_role: userData.user_role,
          mobile_number: userData.mobile_number || "",
          first_name: userData.first_name || "",
          last_name: userData.last_name || "",
          class: userData.educational_info?.class || "",
        });

        console.log("OneSignal user tagged successfully");
      } catch (error) {
        console.error("Error setting OneSignal user tags:", error);
        throw error;
      }
    });
  };

  const logoutUser = async () => {
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        await OneSignal.User.removeTags([
          "last_login",
          "user_id",
          "email",
          "user_role",
          "mobile_number",
          "first_name",
          "last_name",
          "class",
        ]);

        await OneSignal.logout();

        console.log("OneSignal user logged out successfully");
      } catch (error) {
        console.error("Error logging out OneSignal user:", error);
        throw error;
      }
    });
  };

  return { tagUser, logoutUser };
};
